<template>
	<div>
		<table class="mailTable" :style="styleObject" v-if="s_showByRow">
			<tr v-for="index in rowCount">
				<td class="column">{{tableData[index*2-2].key}}</td>
				<td>{{tableData[index*2-2].value}}</td>
				<td class="column">{{tableData[index*2-1] !== undefined ? tableData[index*2-1].key : ''}}</td>
				<td>{{tableData[index*2-1] !== undefined ? tableData[index*2-1].value : ''}}</td>
			</tr>

		</table>
		<table class="mailTable" :style="styleObject" v-else>
			<tr v-for="index in rowCount">
				<td class="column">{{tableData[index-1].key}}</td>
				<td>{{tableData[index-1].value}}</td>
				<td class="column">{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].key : ''}}</td>
				<td>{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].value : ''}}</td>
			</tr>
		</table>
		<el-button type="text" @click="opencomment(status)" class="openBtn" v-if="showFlag">{{status? '展开' : '收起'}}</el-button>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				styleObject: {},
				s_showByRow: true,
				status: true,
				showFlag:false,
			};
		},
		props: ['tableData', 'tableStyle', 'showByRow'],
		computed: {
			rowCount: function() {
				return Math.ceil(this.tableData.length / 2);
			}
		},
		created() {
			this.styleObject = this.tableStyle;
			if (this.showByRow !== undefined) {
				this.s_showByRow = this.showByRow;
			}
			this.$nextTick(function() {
				if($(".mailTable > tr").length>5){
					this.showFlag=true
				}else{
					this.showFlag=false
				}
				let num = $(".mailTable > tr").length - 5
				if ($(".mailTable > tr").length > 5) {
					$(".mailTable tr:gt('" + num + "')").hide();
					this.status = true;
				} else {
					$(".mailTable > tr").show();
					this.status = false;
				}
			})
		},
		methods: {
			opencomment(S) {
				
				let num = $(".mailTable > tr").length - 5
				if (S==true) {
					$(".mailTable > tr").show();
					this.status = false;
				} else {
					$(".mailTable tr:gt('" + num + "')").hide();
					this.status = true;

				}

			}
		}
	}
</script>
<style>
	.mailTable,
	.mailTable tr,
	.mailTable tr td {
		border: 1px solid #E6EAEE;
		padding: 8px 15px;
	}

	.mailTable {
		font-size: 12px;
		color: #71787E;
		margin-bottom: 20px
	}

	.mailTable tr td {
		border: 1px solid #E6EAEE;
		width: 150px;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		padding: 0 10px;
	}

	.mailTable tr td.column {
		background-color: #EFF3F6;
		color: #393C3E;
	}

	.openBtn {
		text-align: center;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/tableComponent.vue